import { render, staticRenderFns } from "./Robo.vue?vue&type=template&id=2af14f13&"
import script from "./Robo.vue?vue&type=script&lang=js&"
export * from "./Robo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports